import { to_array } from "./to_array"

export const ordered_object = (iterable = []) =>
  Object.fromEntries(to_array(iterable))
